import { get, type Writable } from 'svelte/store';
import { copywriterMessagesToPostChildren } from '$lib/ai/post/utils/copywriterMessagesToPostChildren';
import { postToTipTapSchema } from '$textEditor/utils/postToSchema';
import type { Post } from '$lib/api/rpc';
import type { AssistantClient } from '$lib/types/AssistantClient';
import type { PostParent } from '$lib/api/restApi';

const getLastAssistantMessage = (assistantClient: AssistantClient) => {
	return get(assistantClient.state.messages).at(-1);
};

export const processAssistantResponse = (
	assistantClient: AssistantClient,
	post: Writable<PostParent>
) => {
	const assistantResponse = getLastAssistantMessage(assistantClient);
	if (!assistantResponse) {
		return;
	}

	const generatedPostChildren = copywriterMessagesToPostChildren(assistantResponse.content);
	if (!generatedPostChildren) {
		return;
	}

	post.update((currentPost) => ({
		...currentPost,
		children: generatedPostChildren,
	}));
	return postToTipTapSchema(get(post) as Post);
};
